<template>
    <v-app>
        <router-view></router-view>
        <AppService></AppService>
        <LoadingComponent v-if="isShowLoading"/>
    </v-app>
</template>
<script>
import { mapState } from 'vuex'
import AppService from '@/components/AppServiceView'
import LoadingComponent from '@/modules/fptai/components/LoadingComponent'
import '@/assets/css/common.scss'
export default {
    name: 'App',
    components: { AppService, LoadingComponent },
    computed: {
        ...mapState({
            isShowLoading: state => state.isShowLoading
        })
    }
}
</script>
<style>
    html {
        overflow-y: auto !important;
    }
</style>
